<script setup>
import BaseLayout from 'Common/components/layouts/BaseLayout.vue'
</script>

<template>
  <BaseLayout>
    <template #header-content>
      <slot name="header-content" />
    </template>
    <template #main-content>
      <!--Better fallback?-->
      <slot name="main-content">No Site Content</slot>
    </template>
    <template #footer-content>
      <slot name="footer-content" />
    </template>
  </BaseLayout>
</template>
